import React from 'react';
import { Building, CreditCard, Shield, Bell, Users } from 'lucide-react';
import { ORGANISATION } from '../data/demoOrganisation';
export function Settings() {
  return <div className="space-y-8 animate-in fade-in duration-500 max-w-4xl" data-id="element-2296" data-mp="2j55tx32f6w6j">
      <div data-id="element-2297" data-mp="24c2hfa3or8mo">
        <h1 className="text-2xl font-semibold text-slate-900" data-id="element-2298" data-mp="24cc86zwk1jtf">Settings</h1>
        <p className="text-slate-500 mt-1" data-id="element-2299" data-mp="299ukn09s6h66">
          Manage your organization and personal preferences.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8" data-id="element-2300" data-mp="2x19hwempa8ak">
        {/* Settings Nav */}
        <div className="w-full md:w-64 shrink-0" data-id="element-2301" data-mp="3202v05y2rxa7">
          <nav className="space-y-1" data-id="element-2302" data-mp="2n9vlifq1poln">
            <a href="#" className="flex items-center px-3 py-2.5 bg-slate-100 text-slate-900 rounded-md text-sm font-medium" data-id="element-2303" data-mp="2n8u0bifbflq7">
              <Building className="h-4 w-4 mr-3 text-slate-700" data-id="element-2304" data-mp="3fwq4t9b4mhxj" />
              Organization
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2305" data-mp="3kp9j68hn1h3e">
              <Users className="h-4 w-4 mr-3 text-slate-400" data-id="element-2306" data-mp="3ja9aqkk7gn7h" />
              Members & Roles
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2307" data-mp="1tj0zcgvxtz6">
              <Shield className="h-4 w-4 mr-3 text-slate-400" data-id="element-2308" data-mp="auz9tfs1xo1a" />
              Permissions
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2309" data-mp="5w5urix49oz0">
              <Bell className="h-4 w-4 mr-3 text-slate-400" data-id="element-2310" data-mp="2mifh9bss9wkt" />
              Notifications
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2311" data-mp="2hjlz362jxheb">
              <CreditCard className="h-4 w-4 mr-3 text-slate-400" data-id="element-2312" data-mp="3b8jql4ky5gs2" />
              Billing & Plans
            </a>
          </nav>
        </div>

        {/* Settings Content */}
        <div className="flex-1 space-y-6" data-id="element-2313" data-mp="3l798uygr938u">
          <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2314" data-mp="3l8aiqzm1bjoz">
            <div className="p-6 border-b border-slate-200" data-id="element-2315" data-mp="3q5atvoxqrcmy">
              <h2 className="text-lg font-medium text-slate-900" data-id="element-2316" data-mp="3u7xkxnml8tj3">
                Organization Profile
              </h2>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2317" data-mp="2szzoc7r0ag6">
                Update your company details and branding.
              </p>
            </div>
            <div className="p-6 space-y-6" data-id="element-2318" data-mp="7ugym26o9mu4">
              <div className="flex items-center space-x-6" data-id="element-2319" data-mp="crz8pvwfe83p">
                <div className="w-20 h-20 bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center text-slate-400" data-id="element-2320" data-mp="cpmjcxoc8vgm">
                  <Building className="h-8 w-8" data-id="element-2321" data-mp="228uutvok4vxj" />
                </div>
                <div data-id="element-2322" data-mp="1x9hz0lfpkeit">
                  <button className="bg-white border border-slate-200 text-slate-700 px-3 py-1.5 rounded-md text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-2323" data-mp="1x8ynpnkkcodr">
                    Upload Logo
                  </button>
                  <p className="text-xs text-slate-500 mt-2" data-id="element-2324" data-mp="1nclwcwchqmm6">
                    JPG, GIF or PNG. 1MB max.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-6" data-id="element-2325" data-mp="2fzg6p0flg5lx">
                <div data-id="element-2326" data-mp="2g22lnl4tdne6">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2327" data-mp="2b99fcstp66zz">
                    Organization Name
                  </label>
                  <input type="text" defaultValue={ORGANISATION.name} className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-2328" data-mp="269eryz94rzjo" />
                </div>
                <div data-id="element-2329" data-mp="2jj6w0s7e2h2v">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2330" data-mp="2ofnkxomewzh0">
                    Organisation type
                  </label>
                  <select defaultValue={ORGANISATION.type} className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm bg-white" data-id="element-2331" data-mp="29k7k90rbu5bn">
                    <option data-id="element-2332" data-mp="3753mmf9u2xz0">Listed company</option>
                    <option data-id="element-2333" data-mp="2shiici182spi">Private company</option>
                    <option data-id="element-2334" data-mp="2sgqvbvloy3au">Not-for-profit</option>
                    <option data-id="element-2335" data-mp="2xgbyki7w8xtd">Public sector</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end" data-id="element-2336" data-mp="3l54wulbznhr5">
              <button className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-id="element-2337" data-mp="3pxy1zabdcs3r">
                Save Changes
              </button>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2338" data-mp="19ib5r1k7z275">
            <div className="p-6 border-b border-slate-200" data-id="element-2339" data-mp="1o77dexid6d78">
              <h2 className="text-lg font-medium text-slate-900" data-id="element-2340" data-mp="1j848dd2dw6z9">
                Subscription Plan
              </h2>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2341" data-mp="vk4fa6hlo4hi">
                Manage your current tier and features.
              </p>
            </div>
            <div className="p-6" data-id="element-2342" data-mp="qmbclnfi9slz">
              <div className="flex items-center justify-between p-4 border border-indigo-100 bg-indigo-50 rounded-lg" data-id="element-2343" data-mp="14jzwarxu6tpg">
                <div data-id="element-2344" data-mp="10hd0yh1yiqni">
                  <div className="font-semibold text-indigo-900" data-id="element-2345" data-mp="10guvquxbh23g">
                    Enterprise Tier
                  </div>
                  <div className="text-sm text-indigo-700 mt-1" data-id="element-2346" data-mp="2bxbdww099wu0">
                    Includes AI Coaching & Benchmarking
                  </div>
                </div>
                <button className="bg-white border border-indigo-200 text-indigo-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-2347" data-mp="18m5oz2qhwlm0">
                  Manage Plan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}